import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { compose } from 'redux';

import Spinner from 'components/Spinner';
import { fetchQuickMdnHistory } from 'actions/quickSubs';
import { getQuickMdnHistory } from 'reducers';
import MdnHistoriesTable from 'components/quick/MdnHistoriesTable';
import { SubNav } from 'components/SubNav/quick';
import { quickSubPage } from 'decorators/subPage';

export class QuickMdnHistory extends Component {
  state = {
    loading: false,
  };

  componentDidMount() {
    this.fetchMdnHistory();
  }

  fetchMdnHistory = () => {
    const { fetchQuickMdnHistory, subId } = this.props;
    this.setState({ loading: true });

    fetchQuickMdnHistory(subId)
      .catch((e) => {
        toast.error('Failed to load mdn history');
      })
      .finally(() => this.setState({ loading: false }));
  };

  render() {
    const { loading } = this.state;
    const { sub, mdnHistory } = this.props;
    return (
      <div>
        <h1>MDN History</h1>
        <SubNav sub={sub} />
        <MdnHistoriesTable mdnHistory={mdnHistory} />
        <Spinner showLoader={loading} />
      </div>
    );
  }
}

const mapStateToProps = (state, { subId }) => {
  return {
    mdnHistory: getQuickMdnHistory(state, subId),
  };
};

const mapDispatchToProps = {
  fetchQuickMdnHistory,
};

export default compose(
  quickSubPage,
  connect(mapStateToProps, mapDispatchToProps),
)(QuickMdnHistory);
